<template>
  <v-app style="background: #101010">
    <div class="card-back-img">
      <!-- 语言切换 -->
      <div class="posative">
        <div>
          <img class="pos-img" src="@/assets/loge.png" alt="" />
        </div>
        <v-menu class="lang-menu">
          <template #activator="{ on }">
            <v-btn v-on="on" small dense text class="lang-btn">
              <v-icon left>mdi-translate</v-icon>
              {{ currentLangLabel }}
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(lang, index) in languages"
              :key="index"
              @click="changeLang(lang.code)"
            >
              <v-list-item-title>{{ lang.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <!-- 证件照 -->
      <div class="image-container">
        <img
          :src="alldata.cardImg "
          alt=""
          class="centered-image"
        />
      </div>
    </div>
    <div class="isname">
      {{
        nolanguage == "en"
          ? alldata.nameEn
          : nolanguage == "zh"
          ? alldata.name
          : nolanguage == "ar"
          ? alldata.nameA
          : ""
      }}
    </div>
    <div class="position">
      {{
        nolanguage == "en"
          ? alldata.postEn
          : nolanguage == "zh"
          ? alldata.post
          : nolanguage == "ar"
          ? alldata.postA
          : ""
      }}
    </div>
    <v-container class="card-container">
      <!-- 快捷图标 -->
      <div class="social_icons">
        <!-- Whatsaap账号 -->
        <!-- https://wa.me/+966548892663 -->
        <a :href="alldata.whatsapp"
          ><img class="social-icon" src="@/assets/Whatsaap.png" alt="Whatsaap"
        /></a>
        <!-- 邮箱 -->
        <a :href="`mailto:${alldata.email}`" :alt="alldata.email"
          ><img class="social-icon" src="@/assets/envelope.png" alt="envelope"
        /></a>
        <!-- 手机号 -->
        <a :href="`tel:+${alldata?.phone}`"
          ><img class="social-icon" src="@/assets/phone.png" alt="phone"
        /></a>
        <!-- 短信 -->
        <a :href="`sms:+${alldata?.phone}`"
          ><img class="social-icon" src="@/assets/comment.png" alt="comment"
        /></a>
        <!-- 公司官网 -->
        <a href="https://www.hikborei.net/"
          ><img class="social-icon" src="@/assets/globe.png" alt="globe"
        /></a>
      </div>
      <div>
        <!-- 添加联系人 -->
        <v-btn color="darken-1" class="whatsapp-btn" style="margin-right: 10px">
          <a
            :href="`${apiBaseUrl}/system/card/generate-vcf?keyIden=${encodeURIComponent(
              $route.params.key
            )}&language=${nolanguage === 'ar' ? 'a' : nolanguage}`"
            class="custom_btn me-4"
          >
            {{ $t("Addto") }}</a
          >
        </v-btn>

        <!-- 公司位置 -->
        <v-btn color=" darken-1" class="whatsapp-btn">
          <a
            href="https://www.google.com/maps?q=徐运新河东路"
            class="custom_btn"
          >
            {{ $t("address") }}</a
          >
        </v-btn>
      </div>
      <!-- 视频播放 -->
      <div v-if="cardData.videoUrl" class="video-section">
        <video-player :options="videoOptions" class="video-player" />
      </div>
      <div class="company-image">
        <img src="../assets/company.png" alt="" />
      </div>
      <div class="container-text">
        <div class="content-wrapper">
          <div class="header">
            <div class="label">{{ $t("recognize") }}</div>
            <div class="title-a">{{ $t("HikvisionBorui") }}</div>
          </div>
          <div class="paragraph">
            {{ $t("text1") }}
          </div>
          <div class="paragraph">
            {{ $t("text2") }}
          </div>
          <div class="paragraph">
            {{ $t("text3") }}
          </div>
        </div>
      </div>
      <div class="container-text" style="background-color: #000000">
        <div class="content-wrapper">
          <div class="header">
            <div class="label" style="background-color: #68e2fb">
              {{ $t("product") }}
            </div>
            <div class="title-a">{{ $t("RFID") }}</div>
          </div>
          <img
            src="../assets/company-2.png"
            alt=""
            style="width: 100%; margin-top: 20px"
          />
        </div>
      </div>
      <div class="major">
        {{ $t("major") }}
      </div>
      <div style="margin-bottom: -7px">
        <img src="../assets/company-3.png" alt="" style="width: 100%" />
      </div>
      <div class="parbottom">
        {{ $t("text4") }}
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { map } from "@/services/map";
import { loadMessages } from "@/i18n";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import api from "@/services/api";

export default {
  data: () => ({
    langMenu: true,
    nolanguage: "en",
    apiBaseUrl: process.env.VUE_APP_API,
    languages: [
      { code: "en", text: "English" },
      { code: "zh", text: "中文" },
      { code: "ar", text: "العربية" },
    ],
    cardData: {
      // videoUrl: "http://hajjobs.hikhajj.com/guide/TaskManagementImport.mp4",
      // videoUrl: require("@/assets/video.mp4"),
    },
    videoOptions: {
      controls: true,
      responsive: true,
      fluid: true,
      sources: [],
      // poster: require("@/assets/videoimg.png"), // 视频封面
    },

    alldata: {},
    vcfUrl: "",
  }),
  components: {
    "video-player": videoPlayer,
  },

  computed: {
    currentLangLabel() {
      return (
        this.languages.find((l) => l.code === this.$i18n.locale)?.text ||
        "English"
      );
    },
  },

  mounted() {
    const key = this.$route.params.key;

    this.loadCardData(key);
    this.initVideo();
  },

  methods: {
    async loadCardData(key) {
      try {
        const response = await api.fetchCardData(key);
        if (response.code === 200) {
          this.alldata = response.data;
        } else {
        }
      } catch (error) {
        // 错误已由拦截器统一处理
      }
    },

    initVideo() {
      if (this.cardData.videoUrl) {
        this.videoOptions.sources = [
          {
            src: this.cardData.videoUrl,
            type: "video/mp4",
          },
        ];
      }
    },

    changeLang(lang) {
      this.$i18n.locale = lang;
      this.nolanguage = lang;
    },
  },
};
</script>

<style scoped>
.card-container {
  max-width: 800px;
  min-width: 300px;
  margin: 0 auto;
  /* padding: 2rem; */
  text-align: center;
  background: #212121;
  padding: 0 !important;
}

.whatsapp-btn {
  margin-top: 1.5rem;
  border-radius: 58px;
  background-color: #68e2fb !important;
  color: #000;
  font-size: 38px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  transition: all 0.5s ease;
  min-width: 150px !important;
}
.whatsapp-btn:hover {
  background-color: #6ee6b9 !important;
  color: #fff !important;
}
.whatsapp-btn:hover .custom_btn {
  background-color: #6ee6b9 !important;
  color: #fff !important;
}
.custom_btn {
  background: #68e2fb;
  color: #000;
  text-decoration: none; /* 去除下划线 */
  display: block; /* 使链接填充整个按钮 */
  width: 100%;
  height: 100%;
  font-size: 16px;
}
.custom_btn:hover {
  background-color: #6ee6b9 !important;
  color: #fff !important;
}
.video-section {
  margin: 2rem 0;
  border-radius: 8px;
  overflow: hidden;
}

.video-player {
  background: #000;
}
/* 新增视频容器样式 */
.video-section {
  margin: 2rem 0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 宽高比 */
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
}

/* 确保视频元素填满容器 */
.video-player >>> .video-js {
  width: 100% !important;
  height: 100% !important;
}

/* 居中大播放按钮 */
.video-player >>> .vjs-big-play-button {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
.posative {
  /* position: absolute; */
  padding: 12px;
  top: 2%;
  right: 2%;
  z-index: 2;
  display: flex;
  justify-content: space-between;
}
.pos-img {
  height: 40px;
  width: 65px;
}
.lang-menu {
  --v-list-item-title-font-size: 14px; /* 调整文字大小 */
}

.lang-btn {
  padding: 0 10px;
  border-radius: 4px;
  transition: background 0.2s;
}

.lang-btn:hover {
  background: rgba(0, 0, 0, 0.05); /*  hover 效果 */
}

.lang-btn.rtl {
  direction: rtl; /* 阿拉伯语时文字右对齐 */
  /* text-align: right; */
}

.v-list-item {
  cursor: pointer;
}

.v-list-item:hover {
  background: rgba(0, 0, 0, 0.05); /* 菜单项 hover 效果 */
}
.v-btn.v-size--small {
  background-color: #857d7d;
  /* max-width: 75px; */
}
.v-sheet.v-list {
  background-color: #857d7d;
}
.social_icons {
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
}

.social-icon {
  display: block;
  transition: transform 0.2s;
}

.social-icon:hover {
  transform: scale(1.1); /* 悬停时放大效果 */
}

/* 响应式尺寸调整 */
@media (max-width: 600px) {
  .social-icon {
    width: 25px;
    height: 25px;
  }
}

@media (min-width: 601px) {
  .social-icon {
    width: 60px;
    height: 60px;
  }
}

.image-container {
  /* 父容器可省略，直接对图片设置样式也可 */
  text-align: center; /* 子元素（图片）水平居中 */
}
.card-back-img {
  background: url(~@/assets/bg-1.png) no-repeat center/cover;
}
.centered-image {
  max-width: 200px; /* 最大宽度 200px */
  max-height: 300px; /* 最大高度 300px */
  display: block; /* 转换为块级元素，使 margin 生效 */
  margin: 0 auto; /* 水平居中 */
  border-radius: 4px; /* 可选：添加圆角 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 可选：添加阴影 */
}
.isname {
  background: #212121;
  padding-top: 10px;
  font-size: 24px;
  color: #ffffff;
  margin-bottom: -1px;
}
.position {
  padding-top: 5px;
  color: #ffff;
  font-weight: 300;
  background: #212121;
  font-size: 14px;
  margin-bottom: -1px;
}
.company-image {
  margin-top: 40px;
}
.company-image img {
  width: 100%;
}

.container-text {
  background-color: #212121;
  padding: 30px 45px;
}

.header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.label {
  background-color: #fdf251;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
}

.title-a {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}

.paragraph {
  color: #fff;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 15px;
  text-align: left;
}

/* 响应式处理 */
@media (max-width: 480px) {
  .header {
    flex-wrap: wrap;
  }
}
.major {
  padding: 20px 20px 45px 20px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  background-color: #000000;
}
.parbottom {
  color: #fff;
  font-size: 12px;
  line-height: 1.5;
  padding: 30px 45px;
  text-align: left;
  background-color: #000000;
}
</style>